import { FiBookOpen, FiCreditCard, FiFeather } from "react-icons/fi";
import { TbRubberStamp } from "react-icons/tb";
import pricing from "../../assets/data/pricing.json";
import { totalFor } from "./OptionParts";
import { formatPrice } from "../../utils/formatPrice";

// Visual identity services, the cards, brochures and stamps are sold by quantity
export const identityServices = [
  {
    key: "logo",
    icon: FiFeather,
    title: "Logo",
    summary:
      "Un logo professionnel, conçu par nos graphistes, qui reflète l'identité de votre entreprise.",
    prices: { unique: pricing.logo },
  },
  {
    key: "businessCards",
    icon: FiCreditCard,
    title: "Cartes de visite",
    summary:
      "Des cartes de visite à vos coordonnées, pour vous présenter avec soin à vos clients.",
    rule: pricing.businessCards,
    unitLabel: "cartes",
    unitName: "la carte",
  },
  {
    key: "brochures",
    icon: FiBookOpen,
    title: "Plaquettes",
    summary:
      "Des plaquettes pour présenter votre activité et vos offres à vos prospects.",
    rule: pricing.brochures,
    unitLabel: "plaquettes",
    unitName: "la plaquette",
  },
  {
    key: "companyStamp",
    icon: TbRubberStamp,
    title: "Cachet de l'entreprise",
    summary:
      "Un cachet à vos nom et coordonnées, pour authentifier vos factures, devis et documents.",
    rule: pricing.companyStamp,
    unitLabel: "cachets",
    unitLabelOne: "cachet",
    unitName: "le cachet",
  },
];

// Label of the ordered quantity, in the singular for a single item
export const quantityLabel = (option, quantity) =>
  quantity === 1 && option.unitLabelOne
    ? option.unitLabelOne
    : option.unitLabel;

// Unit price, with the ordering rule when it is not one by one
export const unitHint = (option) => {
  const { unit, min, step } = option.rule;
  const price = `${formatPrice(unit)} ${option.unitName}`;

  return min > 1 || step > 1 ? `${price} · minimum ${min}, par ${step}` : price;
};

export const amountFor = (option, state) =>
  option.rule
    ? option.rule.unit * state.quantity
    : totalFor(option.prices, state.periodicity);
